import { render, staticRenderFns } from "./ModalSentMessageError.vue?vue&type=template&id=249e5c47&scoped=true"
import script from "./ModalSentMessageError.vue?vue&type=script&lang=js"
export * from "./ModalSentMessageError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249e5c47",
  null
  
)

export default component.exports